import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import './styles.css'

// After a deploy, an open tab still points at the old chunk files, which are gone: load the new
// version. At most once every 10 s, so a chunk that is really missing cannot loop.
window.addEventListener('vite:preloadError', (e) => {
  let last = 0
  try { last = Number(sessionStorage.getItem('hh-reloaded-at')) || 0 } catch {}
  if (Date.now() - last < 10_000) return
  e.preventDefault()
  try { sessionStorage.setItem('hh-reloaded-at', String(Date.now())) } catch {}
  window.location.reload()
})

const router = createRouter({ routeTree, defaultPreload: 'intent', scrollRestoration: true })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById('app')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
